import styled from 'styled-components';

export const ImportBCPropertiesModalStyled = styled.div``;
